import { Component, Input, OnInit } from '@angular/core';
import { Auth } from '@freelancer/auth';
import { Datastore, DatastoreDocument } from '@freelancer/datastore';
import {
  EncodedUrlCollection,
  EncodedUrlType,
  ProfileViewUsersCollection,
} from '@freelancer/datastore/collections';
import { ButtonColor } from '@freelancer/ui/button';
import { QueryParams } from '@freelancer/ui/link';
import { toNumber } from '@freelancer/utils';
import * as Rx from 'rxjs';
import { map, take } from 'rxjs/operators';

@Component({
  selector: 'app-user-profile-report',
  template: `
    <fl-button
      *ngIf="reportUserParams$ | flAsync as reportUserParams"
      flTrackingLabel="ReportProfileLink"
      i18n="Link for reporting the user"
      [display]="'block'"
      [queryParams]="reportUserParams"
      [link]="'/report/violation'"
      [newTab]="true"
      [color]="ButtonColor.DEFAULT"
    >
      Report User
    </fl-button>
  `,
  styleUrls: ['./user-profile-report.component.scss'],
})
export class UserProfileReportComponent implements OnInit {
  ButtonColor = ButtonColor;

  @Input()
  profileViewUserDocument: DatastoreDocument<ProfileViewUsersCollection>;

  reportUserParams$: Rx.Observable<QueryParams>;

  constructor(private datastore: Datastore, private auth: Auth) {}

  ngOnInit(): void {
    const user$ = this.profileViewUserDocument.valueChanges();

    const encodedUrl$ = this.datastore
      .collection<EncodedUrlCollection>('encodedUrl', query =>
        query
          .where(
            'userId',
            '==',
            this.auth.getUserId().pipe(map(id => toNumber(id))),
          )
          .where('type', '==', EncodedUrlType.URL_SAFE_ENCODE)
          .where(
            'inputUrl',
            '==',
            user$.pipe(map(user => `/u/${user.username}`)),
          ),
      )
      .valueChanges()
      .pipe(
        take(1),
        map(results => results[0]),
      );

    this.reportUserParams$ = Rx.combineLatest([user$, encodedUrl$]).pipe(
      map(([user, encodedUrl]) => ({
        objtype: 'profile',
        encurl: encodedUrl.url,
        objid: `${user.id}`,
      })),
    );
  }
}
